import IndexButtons from "./content/outgoing/SubComponents/IndexButtons";
import StatusIcons from "./content/outgoing/SubComponents/StatusIcons";
import Address from "./content/outgoing/SubComponents/Address";
import { useState, useContext } from "react";
import SettingsContext from "@serie3/common/auth/SettingsContext";
import formatAmount from "./formatAmount";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faFileImport } from "@fortawesome/free-solid-svg-icons";
import FinanceApi from "@serie3/freelancesplaceapi/api/finance/out";

const TableRowBills = ({ index, bill, setShow, setBill, clone, direction, type, deleteFunction, onMarkPaid }) => {
  const { settings } = useContext(SettingsContext);
  const locale = settings?.locale;
  const fmt = (n) => formatAmount(n, locale);

  const editTarget = "/finance/" + direction + "/bills/edit/" + bill.id;
  const [payed, setPayed] = useState(bill.geldeingang);
  const [draft, setDraft] = useState(bill.draft);
  const [imported, setImported] = useState(bill.imported === true);
  const [hovered, setHovered] = useState(false);

  const viewBill = (setShow, setBill, bill) => {
    setShow(true);
    setBill(bill);
  };

  const incoming = bill.eingang === true;
  const sign = incoming ? "-" : "";
  const tax = (bill.brutto || 0) - (bill.netto || 0);
  const accentColor = incoming ? "#c62828" : "#2e7d32";
  const stripeBackground = index % 2 === 0 ? "#fff" : "#f8f9fb";

  const cell = {
    padding: "12px 12px",
    verticalAlign: "middle",
    borderBottom: "1px solid #f5f5f5",
    fontSize: "0.88rem",
    color: "#424242",
  };

  const numCell = {
    ...cell,
    textAlign: "right",
    fontVariantNumeric: "tabular-nums",
  };

  return (
    <tr
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ background: hovered ? "#f5f9ff" : stripeBackground, transition: "background 0.12s" }}
    >
      <td style={cell}>
        <div style={{ fontWeight: 700, color: "#212121", fontSize: "0.92rem" }}>
          #{bill.rechnungs_nummer}
        </div>
        <div style={{ fontSize: "0.76rem", color: "#9e9e9e", marginTop: "2px" }}>
          {bill.datum}
        </div>
      </td>
      <td style={cell}>
        <Address
          addressJson={bill.fixed_address}
          showStreet={false}
          style={{ marginBottom: 0 }}
        />
      </td>
      <td style={cell}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
          <StatusIcons
            payed={payed}
            draft={draft}
            subscription={bill.aborechnung}
            privateButton={bill.privat}
          />
          {!bill.file_name && (
            <span title="No file attached" style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "2px 7px", borderRadius: "6px", background: "#fff3e0", border: "1px solid #ffcc80", color: "#e65100", fontSize: "0.72rem", fontWeight: 700, whiteSpace: "nowrap" }}>
              <FontAwesomeIcon icon={faTriangleExclamation} />
              No file
            </span>
          )}
          {imported && (
            <button
              title="Imported — click to unmark"
              onClick={async (e) => {
                e.stopPropagation();
                const res = await FinanceApi.unmarkImported(bill.id);
                if (res?.status === 200) setImported(false);
              }}
              style={{ display: "inline-flex", alignItems: "center", gap: "4px", padding: "2px 7px", borderRadius: "6px", background: "#e8f0fe", border: "1px solid #93b4f5", color: "#1a73e8", fontSize: "0.72rem", fontWeight: 700, whiteSpace: "nowrap", cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faFileImport} />
              Imported
            </button>
          )}
        </div>
      </td>
      <td style={numCell}>{sign}{fmt(bill.netto)} €</td>
      <td style={{ ...numCell, color: "#9e9e9e" }}>{sign}{fmt(tax)} €</td>
      <td style={{ ...numCell, fontWeight: 700, color: accentColor }}>
        {sign}{fmt(bill.brutto)} €
      </td>
      <td style={{ ...cell, padding: "0 8px" }}>
        <IndexButtons
          index={index}
          viewBill={viewBill}
          setShow={setShow}
          setBill={setBill}
          bill={bill}
          editTarget={editTarget}
          clone={clone}
          direction={direction}
          type={type}
          deleteFunction={deleteFunction}
          payed={payed}
          setPayed={setPayed}
          draft={draft}
          setDraft={setDraft}
          onMarkPaid={onMarkPaid}
        />
      </td>
    </tr>
  );
};

export default TableRowBills;
